import { RequestCreationSuccess } from "@features/cx/shared/components/RequestCreationSuccess";
import { useLocation, useNavigate } from "react-router-dom";

function ComplaintSuccessPage() {
  const navigate = useNavigate();
  // The state contains the merged data from your navigation
  const { formData, ...apiResponse } = useLocation().state || {};
  const requestData = {
    ...apiResponse,
    formData: { ...formData, consumerNo: formData.account_number },
  };
  if (!requestData) {
    return <div>No request data found</div>;
  }
  console.log("formData", formData);
  console.log("apiResponse", apiResponse);
  console.log("useLocation().state", useLocation());

  return (
    <RequestCreationSuccess
      requestData={requestData}
      requestType="complaint"
      onReturnToDashboard={() => navigate("/cx/complaints")}
      onAddNewRequest={() => navigate("/cx/complaints/create#customer-info")}
    />
  );
}

export default ComplaintSuccessPage;
